import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { StudioSiteApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = StudioSiteApiClient;
export const StudioSiteExtension = createModuleExtension({
  extensionName: 'studioSiteExtension',
  Provider,
  SDK: {
    studioSiteApiClient: client
  }
});
//# sourceMappingURL=studio-site.extension.js.map